<template>
  <main class="admin-page">
    <div class="page-heading">
      <div><div class="page-kicker">TRUST & SAFETY</div><h1 class="page-title">信任与安全</h1><div class="page-lead">实名申请、用户反馈与举报在同一处留痕处理。</div></div>
      <el-button icon="el-icon-refresh" @click="load">刷新</el-button>
    </div>

    <el-card shadow="never" class="ops-card">
      <div slot="header" class="card-head"><span>待审实名</span><el-tag size="small" effect="plain">{{ identities.length }}</el-tag></div>
      <el-table :data="identities" empty-text="暂无待审实名申请">
        <el-table-column prop="id" label="用户 ID" width="100" />
        <el-table-column prop="nickname" label="微信昵称" />
        <el-table-column prop="real_name" label="实名姓名" />
        <el-table-column prop="updated_at" label="提交时间" width="180" />
        <el-table-column label="审核" width="180" fixed="right">
          <template slot-scope="{ row }"><el-button size="mini" type="primary" @click="reviewIdentity(row, 'verified')">通过</el-button><el-button size="mini" @click="reviewIdentity(row, 'rejected')">驳回</el-button></template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card shadow="never" class="ops-card">
      <div slot="header" class="card-head"><span>反馈与举报</span><el-radio-group v-model="reportStatus" size="mini" @change="loadReports"><el-radio-button label="pending">待处理</el-radio-button><el-radio-button label="processing">处理中</el-radio-button><el-radio-button label="resolved">已解决</el-radio-button></el-radio-group></div>
      <el-table :data="reports" empty-text="当前没有记录">
        <el-table-column prop="id" label="编号" width="80" />
        <el-table-column prop="nickname" label="提交人" width="130" />
        <el-table-column prop="category" label="类型" width="100" />
        <el-table-column prop="content" label="说明" min-width="280" show-overflow-tooltip />
        <el-table-column prop="created_at" label="提交时间" width="180" />
        <el-table-column label="处理" width="180" fixed="right">
          <template slot-scope="{ row }"><el-button v-if="row.status === 'pending'" size="mini" @click="reviewReport(row, 'processing')">受理</el-button><el-button size="mini" type="primary" @click="reviewReport(row, 'resolved')">完成</el-button></template>
        </el-table-column>
      </el-table>
    </el-card>
  </main>
</template>

<script>
import request from '../api/request'
import ElCard from 'element-ui/lib/card'
import ElRadioButton from 'element-ui/lib/radio-button'
import ElRadioGroup from 'element-ui/lib/radio-group'
import ElTable from 'element-ui/lib/table'
import ElTableColumn from 'element-ui/lib/table-column'
import ElTag from 'element-ui/lib/tag'

export default {
  components: { ElCard, ElRadioButton, ElRadioGroup, ElTable, ElTableColumn, ElTag },
  data() { return { identities: [], reports: [], reportStatus: 'pending' } },
  created() { this.load() },
  methods: {
    async load() { await Promise.all([this.loadIdentities(), this.loadReports()]) },
    async loadIdentities() { const res = await request.get('/realname-requests'); this.identities = res.list || [] },
    async loadReports() { const res = await request.get('/reports', { params: { status: this.reportStatus } }); this.reports = res.list || [] },
    async reviewIdentity(row, status) {
      await request.patch(`/users/${row.id}/realname`, { status })
      this.$message.success(status === 'verified' ? '实名已通过' : '实名已驳回')
      this.loadIdentities()
    },
    async reviewReport(row, status) {
      let resolution = ''
      if (status === 'resolved') {
        const result = await this.$prompt('填写处理结论，便于后续查询', '完成处理', { inputValidator: value => String(value || '').trim().length >= 3 || '请填写至少 3 个字' })
        resolution = result.value
      }
      await request.patch(`/reports/${row.id}`, { status, resolution })
      this.$message.success('处理状态已更新')
      this.loadReports()
    }
  }
}
</script>

<style scoped>
.page-heading, .card-head { display: flex; align-items: center; justify-content: space-between; gap: 18px; }
.page-lead { margin-top: 6px; color: #7c7370; font-size: 13px; }
.ops-card { margin-top: 18px; border-radius: 16px; border-color: #e9e2de; }
.card-head { font-weight: 600; }
</style>
